export const fonts = {
	fontFamily: 'AktivGroteskEx',
	fontFamilyTitle: 'Aktiv Grotesk Ex',
}
